/**
 * 微信公众号自定义菜单接口
 * POST /api/wx-menu/sync 同步公众号当前（默认）菜单（只返回、不入库）
 * POST /api/wx-menu/set  发布并保存菜单（先发布到微信，成功后再入库）
 */
import { apiPost } from '@/utils/request';

/** 菜单按钮（字段与微信 selfmenu_info.button 一致，一级/二级同构） */
export interface WxMenuButton {
  /** 菜单标题 */
  name: string;
  /** 菜单类型：click=回复消息 / view=跳转网页 / miniprogram=跳转小程序 */
  type?: 'click' | 'view' | 'miniprogram';
  /** click 事件 key */
  key?: string;
  /** view / miniprogram 跳转链接 */
  url?: string;
  /** 小程序 appid（type=miniprogram） */
  appid?: string;
  /** 小程序页面路径（type=miniprogram） */
  pagepath?: string;
  /** 二级菜单 */
  sub_button?: WxMenuButton[];
}

/** 同步菜单返回结果 */
export interface WxMenuSyncResult {
  /** 账号 ID */
  app_id: number;
  /** 公众号 appid */
  wx_app_id: string;
  /** 0=默认菜单 / 1=个性化菜单 */
  type: number;
  /** 微信当前生效菜单 */
  menu: WxMenuButton[];
  /** 菜单是否开启：1=开启 0=关闭 */
  status: number;
}

/** 个性化菜单匹配规则（type=1 时必传） */
export interface WxMenuMatchRule {
  tag_id?: string;
  sex?: string;
  country?: string;
  province?: string;
  city?: string;
  client_platform_type?: string;
  language?: string;
}

/** 发布菜单入参 */
export interface WxMenuSetParams {
  /** 公众号 appid */
  wx_app_id: string;
  /** 菜单 button 数组（一级最多 3 个） */
  menu: WxMenuButton[];
  /** 0=默认菜单（默认）/ 1=个性化菜单 */
  type?: number;
  /** 个性化菜单名称（type=1） */
  name?: string;
  /** 个性化菜单匹配规则（type=1） */
  match_rule?: WxMenuMatchRule;
  /** type=1 更新已有个性化菜单时的记录 id */
  id?: number;
}

/** 发布菜单返回结果（入库后的菜单记录） */
export interface WxMenuSetResult {
  id: number;
  app_id: number;
  wx_app_id: string;
  type: number;
  name: string;
  menu: WxMenuButton[];
  match_rule: WxMenuMatchRule | null;
  /** 个性化菜单微信返回的 menuid */
  remote_id: string;
  status: number;
  created_at: string;
  updated_at: string;
}

export const wxMenuApi = {
  /** 同步公众号当前菜单（仅返回、不写库） */
  sync: (wx_app_id: string) => apiPost<WxMenuSyncResult>('/wx-menu/sync', { wx_app_id }),

  /** 发布并保存菜单（先发布到微信，成功后再入库） */
  set: (params: WxMenuSetParams) => apiPost<WxMenuSetResult>('/wx-menu/set', params),
};
